var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-view',{attrs:{"view":_vm.editView,"allow-delete":_vm.name === undefined},on:{"update-view":_vm.updateViewToTeam,"delete-view":_vm.deleteViewToTeam,"cancel":_vm.cancelUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }